import { Reveal, Eyebrow, PageHero, Slate } from "../components/Bits";
import { CHARACTERS } from "../data/show";

const Block = ({ label, children }) => (
  <div><p className="slate text-[var(--coral)]">{label}</p><p className="mt-2 leading-relaxed text-[var(--muted)]">{children}</p></div>
);

const Character = ({ c, i }) => (
  <section id={c.id} className={`section scroll-mt-16 ${i % 2 ? "bg-sand" : ""}`} data-testid={`character-${c.id}`}>
    <div className={`wrap grid lg:grid-cols-[5fr_7fr] gap-12 lg:gap-20 items-start ${i % 2 ? "lg:[&>*:first-child]:order-2" : ""}`}>
      <Reveal>
        <Slate src={c.img} label={`${c.name} / ${c.role}`} className="aspect-[4/5]" testid={`character-${c.id}-portrait`} />
        {c.gallery.length > 0 && (
          <div className="grid gap-4 mt-4">
            {c.gallery.map((g) => <Slate key={g.label} src={g.src} label={g.label} className="aspect-[16/9]" testid={`character-${c.id}-gallery-${g.label.split("/")[1].trim().toLowerCase().replace(/\W+/g, "-")}`} />)}
          </div>
        )}
      </Reveal>
      <Reveal delay={0.1}>
        <Eyebrow>{String(i + 1).padStart(2, "0")} · {c.role}</Eyebrow>
        <h2 className="display text-4xl md:text-6xl mt-3" data-testid={`character-${c.id}-name`}>{c.name}</h2>
        <p className="slate mt-3">{c.alias}</p>
        <p className="mt-8 text-lg leading-relaxed">{c.summary}</p>
        <p className="mt-4 text-sm italic text-[var(--muted)]">{c.look}</p>
        <ul className="traits mt-8">{c.traits.map((t) => <li key={t}>{t}</li>)}</ul>
        <div className="grid sm:grid-cols-2 gap-8 mt-10">
          <Block label="Comedic Engine">{c.comedic}</Block>
          <Block label="The Heart">{c.heart}</Block>
        </div>
        <p className="catch mt-10" data-testid={`character-${c.id}-catchphrase`}>{c.catchphrase}</p>
      </Reveal>
    </div>
  </section>
);

export default function Characters() {
  return (
    <div data-testid="characters-page">
      <PageHero testid="characters-hero" eyebrow="The Ensemble" title="One Star. Two Siblings. One Very Confused Human." sub="Full breakdowns for everyone living on, or passing through, the hilltop." />
      <div className="wrap pt-10 flex flex-wrap gap-3">
        {CHARACTERS.map((c) => <a key={c.id} href={`#${c.id}`} className="chip" data-testid={`jump-${c.id}`}>{c.name}</a>)}
      </div>
      {CHARACTERS.map((c, i) => <Character key={c.id} c={c} i={i} />)}
    </div>
  );
}
